import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import { mapActions } from 'vuex'
//引入antd-vue
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
//引入bootstrap样式
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
//引入iconfont样式
import './assets/font/iconfont.css'
//引入全局公共样式
import './assets/css/common.css'

// 引入 moment
import moment from 'moment';

Vue.prototype.$moment = moment;

import { timeFix } from '@/utils/common'

// 引入echarts
import * as echarts from "echarts"
Vue.prototype.$echarts = echarts

// 全局获取筛选条件
import { searchList } from '@/api/api';

//关闭生产提示
Vue.config.productionTip = false

Vue.use(Antd)
Vue.use(router)

new Vue({
  store,
  router,
  
  // 将筛选条件存在 store 中
  mounted() {
	if(this.getCookie("TOKEN") !== ''){
		this.GetUserInfo()
	}
    searchList('policy_Class_ification').then(res => {
		localStorage.setItem('levelOptions', JSON.stringify(res.data));
    })
	searchList('sending_System').then(res => {
		let temp = res.data[0];
		res.data[0] = res.data[1]
		res.data[1] = temp;
		// console.log(res)
		localStorage.setItem('systemList', JSON.stringify(res.data));
	})
	searchList('policy_Theme').then(res => {
		localStorage.setItem('themeList', JSON.stringify(res.data));
	})
	searchList('applicable_Range').then(res => {
		localStorage.setItem('appList', JSON.stringify(res.data));
	})
	searchList('applicable_Enterprise').then(res => {
		localStorage.setItem('enterpriseList', JSON.stringify(res.data));
	})
  },
  methods:{
    ...mapActions(['GetUserInfo']),
	 getCookie(name) {
	     const cookies = document.cookie.split("; ")
	     for (let i = 0; i < cookies.length; i++) {
	       const cookie = cookies[i].split("=")
	       if (cookie[0] === name) {
	         return cookie[1]
	       }
	     }
	     return ""
	 },
	 getUserInfo(){
		this.GetUserInfo().then(() => {
		   this.$message.success(`${timeFix()}，欢迎回来`)
		   // setTimeout(() => {
		   //   this.$router.replace({ path: this.$route.query.redirect || '/' })
		   // }, 500)
		})
	 }
	 
  },
  render: h => h(App),
}).$mount('#app')
